import styled from 'styled-components';
import { extraDarkPurple, iconClose, regularWhite } from '../design-tokens';
import { playFontIcon } from '../typography/helpers';
import { playFocus } from '../utils.styles';

export const StyledOnboarding = styled.div`
    position: relative;
    background: ${extraDarkPurple};
    padding: 15px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    :before {
        content: '';
        position: absolute;
        top: 100%;
        left: 20px;
        width: 0;
        border-top: 10px solid ${extraDarkPurple};
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
    }
`;

export const StyledOnboardingContent = styled.div``;

export const StyledOnboardingClose = styled.button`
    align-self: flex-start;
    appearance: none;
    border: none;
    background: none;
    ${playFocus()};
    padding-right: 0;
    &:before {
        color: ${regularWhite};
        ${playFontIcon(1.6, iconClose)}
    }
`;
